import Vue from "vue"
export default {
  changeElementType(state, type) {
    if (state.isClonePattern || state.isOrderPattern) {
      return
    }
    state.elementType = type
  },
  changeRightBtnStatu(state, data) {
    state.showRightBtn = data
  },
  changePageList(state, data) {
    //判断当前页面是否为新建 新建页面需要将页面的模式改为布局模式
    // if(!state.page.isPhoneFullScreen){
    //   let curPage
    //   for(let i=0;i<data.length;i++){
    //     if(data[i].publicId == state.getDataPageIds.pageId){
    //       curPage = data[i]
    //       break
    //     }
    //   }
    //   let createTime = curPage.createTime.split(" ")
    //   let createTime1 = createTime[0].split("-")
    //   let createTime2 = createTime[1].split(":")
    //   let createTimeArr =  createTime1.concat(createTime2)
    //   let date = new Date()
    //   let nowDate = [date.getFullYear(),date.getMonth()+1,date.getDate(),date.getHours(),date.getMinutes(),date.getSeconds()]
    //
    //   let pageIsNew = true
    //   // -2 是省掉分和秒
    //   for(let j=0;j<nowDate.length-3;j++){
    //     if(nowDate[j]>createTimeArr[j]){
    //       pageIsNew = false
    //       break
    //     }
    //   }
    //   if(pageIsNew){
    //     Vue.set(state, "pageLayoutType", "layOut")
    //   }
    // }
    state.pageList = data
  },
  changeDragMode(state, data) {
    state.dragMode = data
  },
  changeLeftMenuDragStatu(state, data) {
    state.leftMenuDragStatus = data
  },
  changeShowPluginSetting(state, data) {
    state.showPluginSetting = data
  },
  changeActiveID(state, data) {
    if (state.isClonePattern || state.isOrderPattern) {
      return
    }
    if (data === null) {
      Object.keys(state.activeID).forEach(item => {
        if (item !== "container_id") {
          Vue.set(state.activeID, `${item}`, null)
        }
      })
      return
    }
    const dataKeys = []
    Object.keys(data).forEach(key => {
      dataKeys.push(key)
      if(key==='pageLayoutId' && typeof data[key] === 'number'){
        Vue.set(state.activeID, key, data[key].toString())
      }else{
        Vue.set(state.activeID, key, data[key])
      }
    })
    Object.keys(state.activeID).forEach(idsKey => {
      if (!dataKeys.find(item => item === idsKey)) {
        Vue.set(state.activeID, idsKey, null)
      }
    })
  },
  changeToolBarStatus(state, data) {
    if (state.isClonePattern || state.isOrderPattern) {
      return
    }
    if (Vue.prototype.request_prefix === "bigScreen") {
      state.toolBarStatus = true
      if (state.activeID.container_id === null) {
        Vue.set(state.activeID, "container_id", 0)
      }
    } else {
      state.toolBarStatus = data
    }
  },
  changeActiveGridIdStatus(state, data) {
    state.activeGridId = data
  },
  changeAlignHelperStatus(state, data) {
    window.localStorage.setItem("alignHelperStatus", JSON.stringify(data))
    state.alignHelperStatus = data
  },
  updateDataPageIds(state, data) {
    Object.keys(data).forEach(key => {
      Vue.set(state.getDataPageIds, key, data[key])
    })
  },
  updateMyCookie(state, data) {
    Vue.set(state, "myCookie", data)
  },
  // 将图标svg全部存起来，避免请求多次
  updateSvg(state, data) {
    let tempData = {}
    tempData[data.svgId] = data.value
    if (!state.iconSvg) {
      Vue.set(state, "iconSvg", {})
    }
    Vue.set(state, "iconSvg", {
      ...state.iconSvg,
      ...tempData
    })
  },
  updateUserInfo(state, data) {
    Vue.set(state, "userInfo", data)
  },
  updateUserPermissionCode(state, data) {
    Vue.set(state, "userPermission", data)
  },
  changeShowLeftMenuStatus(state, data) {
    state.showLeftMenu = data
  },
  changeDraggingStatus(state, data) {
    state.dragStatus = data
  },
  changeShowRightMenuStatus(state, data) {
    state.showRightMenu = data
  },
  changeShowRulerStatus(state, data) {
    state.showRuler = data
  },
  changePageZoom(state, data) {
    state.zoom = data
  },
  clearPageZoom(state) {
    state.zoom = undefined
  },
  changePageZoomActual(state, data) {
    state.zoomActual = data
  },
  changeShowRightToolbarStatus(state, data) {
    state.showRightToolbar = data
  },
  changeShowEditShape(state, data) {
    state.showEditShape = data
  },
  changeShowAllScreenStatus(state, data) {
    state.showAllScreen = data
  },
  changeManagerType(state, data) {
    state.managerType = data
  },
  changeShowLeftMenusStatus(state, data) {
    state.showLeftMenus = data
  },
  changeShowComponentName(state, data) {
    state.showComponentName = data
  },
  changeLogicTextDynamicId(state, data) {
    state.logicTextDynamicId = data
  },
  changeIsUpdateLayerDataFlag(state, data) {
    state.isUpdateLayerDataFlag = data
  },
  changeGeneralAttr(state, data) {
    state[data.valName] = data.val
  },
  changeListPageTemplateEncId(state, data) {
    Vue.set(state, "listPageTemplateEncId", data)
  },
  changeDetailPageTemplateEncId(state, data) {
    Vue.set(state, "detailPageTemplateEncId", data)
  },
  changeHomePageName(state, data) {
    state.homePageName = data
  },
  changeSubPageName(state, data) {
    state.subPageName = data
  },
  // 增加状态记录
  addHistoryState(state, data) {
    state.historyState.splice(state.historyIndex + 1, 30)
    state.historyState.push(data)
    const stateLens = state.historyState.length
    if (stateLens > 30) {
      state.historyState.shift()
    } else {
      state.historyIndex++
    }
    console.log(
      `%c addState<current: ${state.historyIndex}, total: ${state.historyState.length}, type: ${data.type}, stateType: ${data.stateType}>`,
      "background: green;color: white"
    )
    console.log("data: ", data)
  },
  // 更新状态
  updateHistory(state, data) {
    state.historyState[data.index] = data.state
    console.log(
      `%c updateState<current: ${state.historyIndex}, total: ${state.historyState.length}, type: ${data.state.type}, stateType: ${data.state.stateType}>`,
      "background: #67c23a;color: white"
    )
    console.log("data: ", data.state)
  },
  // 撤销回上一个状态
  goBackHistory(state) {
    state.historyIndex--
  },
  // 恢复回下一个状态
  goNextHistory(state) {
    state.historyIndex++
  },
  // 清空状态记录
  clearHistoryState(state) {
    state.historyState = []
    state.historyIndex = -1
    sessionStorage.removeItem("historyValueCombine")
  },
  // 是否正在生成通栏链接，这里需要调用预览
  changeCopyLinkStatus(state, data) {
    state.generatingCopyLink = data
  },
  changeProps(state, data) {
    state[data.option_name] = data.option_val
  }
}
